import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconIntelligence = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("g", { clipPath: "url(#ati)" },
                React.createElement("path", { fillRule: "evenodd", d: "M19.954 0H19l-1 3-3 1v1l3 1 1 3h.954L21 6l3-1V4l-3-1-1.046-3ZM9.907 6H8l-2 6-6 2v2l6 2 2 6h1.907L12 18l6-2v-2l-6-2-2.093-6Z", clipRule: "evenodd" })),
            React.createElement("defs", null,
                React.createElement("clipPath", { id: "ati" },
                    React.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" }))))));
};
